
import './leftTextRightWidget.css'
import AnimationLoop from '../animationLoop/animationLoop'
import AppDownloadWidget from './appDownloadWidget'
import logo from '../assets/factura247.svg'

export default function LeftTextRightWidget() {
    return (
        <section className="ltw-container" id="descargar" aria-label="Hero - Factur 24/7">
            {/* Animation layer: full-bleed background, sits behind the overlay */}
            <div className="ltw-anim" aria-hidden="true">
                <AnimationLoop />
            </div>

            {/* Overlay layer: gradient + text floats on top of the animation */}
            <div className="ltw-overlay">
                <div className="ltw-left">
                    <div style={{ height: '50px' }}></div>
                    <img
                        src={logo}
                        alt="Factur 24/7 logo"
                        className="ltw-logo"
                        width="200"
                        height="220"
                        loading="eager"
                        fetchPriority="high"
                    />
                    <div style={{ height: '40px' }}></div>
                    <div className="ltw-content-up">
                        <p className="ltw-eyebrow">Facturación electrónica · SRI Ecuador</p>
                        <h2 className="ltw-title">FACTUR <span className="ltw-title-accent">24/7</span></h2>
                        <div style={{ height: '20px' }}></div>
                        <p className="ltw-paragraph">
                            Emite facturas electrónicas, notas de crédito y proformas desde cualquier dispositivo,
                            en cualquier momento. Si no tienes conexión, tus documentos se pueden guardar localmente y enviar después.
                        </p>
                        <div style={{ height: '20px' }}></div>
                        <p className="ltw-paragraph ltw-paragraph--secondary">
                            Disponible para Android, Windows, Linux, macOS y Web. Gratis para empezar.
                        </p>
                    </div>
                    <div style={{ height: '50px' }}></div>
                    <AppDownloadWidget />
                    <div style={{ height: '50px' }}></div>
                </div>
            </div>
        </section>
    )
}
